export default __webpack_public_path__ + "static/media/Strap CT Too Big.d1636ef8.png";